import styled from 'styled-components';

export const StyledTable = styled.table`
    width: 100%;
    td,
    th {
        padding-top: 0.6rem;
        padding-bottom: 0.6rem;
        font-size: 1.4rem;
    }
    th {
        font-weight: bold;
        text-align: left;
    }
`;

export const NotificationTriggerTableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export function NotificationTriggerTable({ rows }: { rows: JSX.Element[] }) {
    return (
        <StyledTable>
            <thead>
                <tr>
                    <th>Notification Properties</th>
                    <th>Email</th>
                    <th>Text</th>
                </tr>
            </thead>
            <tbody>{rows}</tbody>
        </StyledTable>
    );
}
